import { SectionContent } from 'app/views/presentations/models/sectionContent.model';

export class WebPageModel extends SectionContent {

    constructor(
        public url: string
    ) {
        super();
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/webpage/webpage.model.ts